import { FC } from 'react';
import { Avatar, cn } from 'fe-learner-common';
import { TPerson } from '@api/io/session.io';

type PersonProps = {
  person: TPerson;
};

export const Person: FC<PersonProps> = ({ person }) => {
  return (
    <div
      className={cn(
        'lf:relative lf:flex lf:items-center lf:gap-4 lf:rounded-lg lf:border-1 lf:border-neutral-200 lf:p-2',
      )}
    >
      <Avatar
        size="lg"
        src={person.thumbnail || undefined}
        alt=""
        aria-hidden
      />
      <div className="lf:flex lf:flex-col lf:items-start lf:gap-1">
        <h3 className="lf:text-label-lg ">{person.name}</h3>
      </div>
    </div>
  );
};
